import * as React from "react";
import { forwardRef } from "react";
const SvgUpload = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} ref={ref} {...props}><path fillRule="evenodd" d="M13 16a1 1 0 1 1-2 0V6.414L7.707 9.707a1 1 0 0 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L13 6.414V16Zm-8 3a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5Z" clipRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgUpload);
export default ForwardRef;